import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import Icon from "../components/Icon";
import { leadership } from "../data/content";

export default function Team() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "PT. Bumi Cakrawala Logistik",
    employee: [
      { "@type": "Person", name: leadership.ceo.name, jobTitle: leadership.ceo.role },
      ...leadership.team.map((t) => ({ "@type": "Person", name: t.name, jobTitle: t.role })),
    ],
  };

  return (
    <>
      <Seo path="/team" jsonLd={jsonLd} />

      <header className="page-hero">
        <div className="page-hero__bg">
          <img src="/images/truck-tunnel.jpg" alt="Freight truck moving through an elevated concrete corridor" />
        </div>
        <div className="container page-hero__inner">
          <span className="page-hero__crumb">
            <Link to="/">Home</Link> / Team
          </span>
          <h1>Management &amp; Team</h1>
          <p>
            The people behind every shipment, project, and partnership at Bumi
            Logistics.
          </p>
        </div>
      </header>

      <section className="section">
        <div className="container">
          <div className="ceo-card">
            <div className="ceo-card__photo">
              <img src={leadership.ceo.photo} alt={`Portrait of ${leadership.ceo.name}, ${leadership.ceo.role}`} />
            </div>
            <div>
              <span className="eyebrow">Management</span>
              <h2 style={{ marginTop: 10 }}>{leadership.ceo.name}</h2>
              <span className="ceo-card__role">{leadership.ceo.role}</span>
              {leadership.ceo.bio.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="section section--alt">
        <div className="container">
          <div className="section-head">
            <span className="eyebrow">Our Team Members</span>
            <h2>Leadership Team</h2>
          </div>
          <div className="team-grid">
            {leadership.team.map((member) => (
              <article className="team-card" key={member.name}>
                <div className="team-card__photo">
                  <img src={member.photo} alt={`Portrait of ${member.name}, ${member.role}`} />
                </div>
                <div>
                  <h3>{member.name}</h3>
                  <span className="team-card__role">{member.role}</span>
                  <p>{member.bio}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section section--tight">
        <div className="container">
          <div className="cta-banner">
            <h2>Want to work with our team?</h2>
            <Link to="/contact" className="btn btn-dark">
              Get In Touch <Icon name="arrowRight" size={18} />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
